import { render, staticRenderFns } from "./OFirstLoginModal.vue?vue&type=template&id=5ace26de"
import script from "./OFirstLoginModal.vue?vue&type=script&lang=js"
export * from "./OFirstLoginModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports